import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=7b74d1e0&scoped=true"
import script from "./CatalogForm.vue?vue&type=script&lang=js"
export * from "./CatalogForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&id=7b74d1e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74d1e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b74d1e0')) {
      api.createRecord('7b74d1e0', component.options)
    } else {
      api.reload('7b74d1e0', component.options)
    }
    module.hot.accept("./CatalogForm.vue?vue&type=template&id=7b74d1e0&scoped=true", function () {
      api.rerender('7b74d1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/catalog/CatalogForm.vue"
export default component.exports